import { Pagination, Empty, Spin } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../component/Footer';
import parse from "html-react-parser";
import { CalendarOutlined, ArrowRightOutlined } from '@ant-design/icons';
import logo from '../component/image/logo.png';

export default function Blog() {
    const [news, setdataNews] = useState({});
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 6,
    });

    const getNews = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/getAll`, { params: pagination });
            setdataNews(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getNews();
    }, [pagination]);

    const stripHtml = (html) => {
        if (!html) return '';
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        return d.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    return (
        <>
            <div className="min-h-screen bg-[#0a1628]">
                {/* Hero Section */}
                <div className="bg-gradient-to-r from-[#0f1e35] to-[#1a2d4a] text-white py-16 border-b border-white/10">
                    <div className="max-w-screen-xl mx-auto px-6 text-center">
                        <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Blog & Tin Tức</h1>
                        <p className="text-lg text-blue-300 max-w-2xl mx-auto">Chia sẻ kiến thức, kinh nghiệm và bí quyết học tiếng Anh hiệu quả</p>
                    </div>
                </div>

                <div className="max-w-screen-xl mx-auto px-6 py-12">
                    {loading ? (
                        <div className="flex justify-center py-20">
                            <Spin size="large" />
                        </div>
                    ) : !news?.data || news.data.length === 0 ? (
                        <div className="py-20">
                            <Empty description={<span className="text-gray-400">Chưa có bài viết nào</span>} />
                        </div>
                    ) : (
                        <>
                            {/* Featured Post (first post) */}
                            {pagination.page === 1 && news.data.length > 0 && (
                                <div className="mb-12">
                                    <Link to={"/blog/" + news.data[0]?.blog_slug} className="block group">
                                        <div className="bg-[#0f1e35] border border-white/10 rounded-2xl overflow-hidden hover:border-white/20 transition-all duration-300 group-hover:-translate-y-1">
                                            <div className="grid grid-cols-1 md:grid-cols-2">
                                                <div className="h-64 md:h-full min-h-[300px] overflow-hidden">
                                                    <img
                                                        src={news.data[0]?.blog_image || logo}
                                                        alt={news.data[0]?.blog_title}
                                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                                        crossOrigin="anonymous"
                                                        onError={(e) => { e.target.onerror = null; e.target.src = logo; }}
                                                    />
                                                </div>
                                                <div className="p-8 flex flex-col justify-center">
                                                    <div className="inline-flex items-center gap-2 text-sm text-blue-400 bg-blue-500/10 px-3 py-1 rounded-full w-fit mb-4">
                                                        <CalendarOutlined />
                                                        <span>{formatDate(news.data[0]?.create_at)}</span>
                                                    </div>
                                                    <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 group-hover:text-blue-400 transition-colors line-clamp-2">
                                                        {news.data[0]?.blog_title}
                                                    </h2>
                                                    <p className="text-gray-400 line-clamp-3 mb-6">
                                                        {stripHtml(news.data[0]?.blog_description)}
                                                    </p>
                                                    <span className="inline-flex items-center gap-2 text-blue-400 font-semibold group-hover:gap-3 transition-all">
                                                        Đọc tiếp <ArrowRightOutlined />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )}

                            {/* Blog Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                                {news.data.slice(pagination.page === 1 ? 1 : 0).map((item, index) => (
                                    <Link to={"/blog/" + item?.blog_slug} key={index} className="block group">
                                        <article className="bg-[#0f1e35] border border-white/10 rounded-xl overflow-hidden hover:border-white/20 transition-all duration-300 group-hover:-translate-y-1 h-full flex flex-col">
                                            <div className="h-52 overflow-hidden relative">
                                                <img
                                                    src={item?.blog_image || logo}
                                                    alt={item?.blog_title}
                                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                                    crossOrigin="anonymous"
                                                    onError={(e) => { e.target.onerror = null; e.target.src = logo; }}
                                                />
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                                            </div>
                                            <div className="p-5 flex flex-col flex-1">
                                                <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                                                    <CalendarOutlined />
                                                    <span>{formatDate(item?.create_at)}</span>
                                                </div>
                                                <h3 className="text-lg font-bold text-white mb-3 line-clamp-2 group-hover:text-blue-400 transition-colors">
                                                    {item?.blog_title}
                                                </h3>
                                                <p className="text-gray-400 text-sm line-clamp-3 flex-1">
                                                    {stripHtml(item?.blog_description)}
                                                </p>
                                                <div className="mt-4 pt-4 border-t border-white/10">
                                                    <span className="inline-flex items-center gap-2 text-sm text-blue-400 font-semibold group-hover:gap-3 transition-all">
                                                        Đọc tiếp <ArrowRightOutlined />
                                                    </span>
                                                </div>
                                            </div>
                                        </article>
                                    </Link>
                                ))}
                            </div>

                            {/* Pagination */}
                            {news?.total > pagination.pageSize && (
                                <div className="flex justify-center mt-12">
                                    <Pagination
                                        current={pagination.page}
                                        total={news?.total}
                                        pageSize={pagination.pageSize}
                                        showSizeChanger={false}
                                        onChange={(p, ps) => setPagination({ page: p, pageSize: ps })}
                                        className="custom-pagination"
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};
